'use client';
import { pick } from '@chakra-ui/utils';
import { useEditableContext } from './editable-context.mjs';

function useEditableState() {
  const api = useEditableContext();
  return pick(api, ["isEditing", "onSubmit", "onCancel", "onEdit"]);
}
function useEditableControls() {
  const api = useEditableContext();
  return pick(api, [
    "isEditing",
    "getEditButtonProps",
    "getCancelButtonProps",
    "getSubmitButtonProps"
  ]);
}

export { useEditableControls, useEditableState };
